export default "<div *ngIf=\"text\" [class]=\"class\" role=\"alert\">\r\n  {{text}}\r\n</div>\r\n"